import { CSSProperties, Flex, FlexProps } from '@mantine/core';
import classes from './Card.module.css';

export const Card = ({
  children,
  flexProps,
  style,
  className,
  size,
  direction,
  onClick,
}: {
  children: JSX.Element | JSX.Element[];
  flexProps?: FlexProps;
  style?: CSSProperties;
  className?: string;
  size?: 'small' | 'medium';
  direction?: 'column' | 'row';
  onClick?: () => void;
}) => {
  return (
    <Flex
      className={`${size === 'small' ? classes.smallCard : classes.card} ${className}`}
      {...flexProps}
      style={style}
      direction={direction ?? 'column'}
      onClick={onClick}
    >
      {children}
    </Flex>
  );
};
